<template>
   <svg name="tick" viewBox="0 0 28 21" aria-hidden="true" focusable="false">
      <path
         d="M10.1609 20.5L0.563965 10.9031L3.2703 8.19674L10.1609 15.0681L24.729 0.5L27.4354 3.22553L10.1609 20.5Z"
      />
   </svg>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped></style>
